// extracted by mini-css-extract-plugin
export var container = "title-image-module--container--1xxp5";
export var imageContainer = "title-image-module--imageContainer--2Gu5o";
export var imageContainerLeft = "title-image-module--imageContainerLeft--3BcH5";
export var imageContainerCenter = "title-image-module--imageContainerCenter--29TMQ";
export var imageContainerRight = "title-image-module--imageContainerRight--1Foly";
export var bottomStyle = "title-image-module--bottomStyle--JqKxL";
export var image = "title-image-module--image--1ICRG";
export var mobile = "title-image-module--mobile--33Nk_";
export var mobileImage = "title-image-module--mobileImage--2a2z2";